// extracted by mini-css-extract-plugin
export default {"page":"styles_page__vjT3x","searchRow":"styles_searchRow__Gdmqj"};